import React from "react";
import PropTypes from "prop-types";

const TaskCard = ({ icon, heading, children }) => {
  return (
    <div className="task-card">
      <div className="task-card__image mb-20">
        {icon && <img src={icon} alt="Task" className="img-responsive" />}
      </div>
      <div className="task-card__heading mb-10">{heading}</div>
      <div className="task-card__content">{children}</div>
    </div>
  );
};

TaskCard.propTypes = {
  icon: PropTypes.string,
  heading: PropTypes.string
};

export default TaskCard;
